module.exports = {
  RG_API_URL: 'https://api.resourceguruapp.com',
  CLIENT_ID: 'zBlhKVqmBbCAERMG2KdIzkPhJTYt7W6i_ius-rKA9Ls',
  CLIENT_SECRET: 'RpXTKCkUWIcBx80OqvZ_xrxEVO5mYel3iNYEcsM2QAw',
  REDIRECT_URI: 'https://rgviewer.int.optimo-it.com/oauth',
  API_URL: 'https://rgviewer.int.optimo-it.com/api',
};
